export type TimePrefs = {
  timezone?: string; // IANA tz, e.g., "America/Los_Angeles"
};

export function getBrowserTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
}

export function formatNow(tz?: string) {
  const timeZone = tz || getBrowserTimeZone();
  const now = new Date();
  const date = new Intl.DateTimeFormat(undefined, { timeZone, dateStyle: "medium" }).format(now);
  const time = new Intl.DateTimeFormat(undefined, { timeZone, timeStyle: "short" }).format(now);
  return `${date} • ${time}`;
}
